<div class="summary-page">
  <app-monthly-selector
    [selectedMonth]="selectedMonth"
    [selectedYear]="selectedYear"
    [daysInMonth]="daysInMonth"
    [isKumMode]="isKumMode"
    [isCallCenterEmployee]="isCurrentUserCallCenterEmployee"
    [isKumEmployee]="isCurrentUserKum"
    [isBothCcAndKum]="isCurrentUserBothCcAndKum"
    [exportDisabled]="isExportDisabled()"
    [isExporting]="isExporting"
    (monthChange)="onMonthChange($event)"
    (yearChange)="onYearChange($event)"
    (modeChange)="onModeChange($event)"
    (exportRequested)="onExportRequested()">
  </app-monthly-selector>

  <div class="tables-section">
    <!-- Éves nézet (összes hónap) -->
    @if (isYearlyView) {
      @for (colleagueWithMetrics of (isKumMode ? kumColleaguesWithMetrics : colleaguesWithMetrics); track colleagueWithMetrics.colleague.id; let i = $index) {
        <div class="colleague-section">
          <app-yearly-statistics-table
            [year]="selectedYear"
            [colleagueName]="colleagueWithMetrics.colleague.username"
            [userId]="colleagueWithMetrics.colleague.id"
            [isKumMode]="isKumMode">
          </app-yearly-statistics-table>
        </div>
      }

      <!-- Éves összesítő táblázat -->
      @if ((isKumMode ? kumColleaguesWithMetrics : colleaguesWithMetrics).length > 0 && !isCurrentUserCallCenterEmployee && !isCurrentUserKum) {
        <div class="summary-table-container">
          <app-yearly-statistics-table
            [year]="selectedYear"
            [colleagueName]="'Összesen'"
            [userId]="0"
            [isKumMode]="isKumMode"
            [isSummaryTable]="true"
            [allColleaguesData]="yearlyAllColleaguesData">
          </app-yearly-statistics-table>
        </div>
      }
    } @else {
      <!-- Havi nézet - csak a megfelelő mód bulk betöltése után renderelünk -->
      @if ((!isKumMode && preloadedStatsMap !== null) || (isKumMode && preloadedKumStatsMap !== null)) {
        @for (colleagueWithMetrics of (isKumMode ? kumColleaguesWithMetrics : colleaguesWithMetrics); track colleagueWithMetrics.colleague.id; let i = $index) {
          <div class="colleague-section">
            <app-statistics-table
              [month]="selectedMonth"
              [year]="selectedYear"
              [daysInMonth]="daysInMonth"
              [metrics]="colleagueWithMetrics.performanceMetrics"
              [colleagueName]="colleagueWithMetrics.colleague.username"
              [userId]="colleagueWithMetrics.colleague.id"
              [isKumMode]="isKumMode"
              [canEditPlan]="canEditPlan"
              [preloadedStats]="getPreloadedStatsForUser(colleagueWithMetrics.colleague.id)"
              [preloadedKumStats]="getPreloadedKumStatsForUser(colleagueWithMetrics.colleague.id)"
              [otherColleagues]="getOtherColleagues(colleagueWithMetrics.colleague.id)"
              (planDataSaved)="onPlanDataSaved($event)"
              (copyPlanRequested)="onCopyPlanRequested(colleagueWithMetrics.colleague, $event)">
            </app-statistics-table>
          </div>
        }

        <!-- Összefoglaló táblázat - csak nem Call Center és nem KÜM munkatársak számára -->
        @if ((isKumMode ? kumColleaguesWithMetrics : colleaguesWithMetrics).length > 0 && !isCurrentUserCallCenterEmployee && !isCurrentUserKum) {
          <div class="summary-table-container">
            <app-statistics-table
              #summaryTable
              [month]="selectedMonth"
              [year]="selectedYear"
              [daysInMonth]="daysInMonth"
              [metrics]="[]"
              [colleagueName]="'Összesen'"
              [userId]="0"
              [isKumMode]="isKumMode"
              [canEditPlan]="canEditPlan"
              [isSummaryTable]="true"
              [allColleaguesWithMetrics]="isKumMode ? kumColleaguesWithMetrics : colleaguesWithMetrics"
              [preloadedAllStatsMap]="isKumMode ? null : preloadedStatsMap"
              [preloadedAllKumStatsMap]="isKumMode ? preloadedKumStatsMap : null">
            </app-statistics-table>
          </div>
        }
        } <!-- /mód-specifikus preloaded check -->
      }
    </div>
  </div>